/**
 * FAQ Accordion Frontend JavaScript
 * Handles GSAP animations for accordion functionality
 */

(function () {
	"use strict";

	// Wait for GSAP to be available
	function waitForGSAP() {
		return new Promise((resolve) => {
			if (typeof gsap !== "undefined") {
				resolve();
			} else {
				const checkGSAP = setInterval(() => {
					if (typeof gsap !== "undefined") {
						clearInterval(checkGSAP);
						resolve();
					}
				}, 100);
			}
		});
	}

	// Initialize Process Steps functionality
	function initProcessSteps() {
		const isMobile = () => window.innerWidth < 1024;
		let currentBreakpoint = isMobile() ? 'mobile' : 'desktop';
		let scrollTriggers = [];
		
		// Track which elements have already been animated
		const animatedElements = new Set();
		const animatedWrappers = new Set();

		// Clear scroll triggers but preserve animation state
		const clearScrollTriggers = () => {
			scrollTriggers.forEach(st => st.kill());
			scrollTriggers = [];
		};

		// Mobile animation function
		const initMobileAnimations = () => {
			const fadeInUp = document.querySelectorAll(".process-step");
			
			if (fadeInUp.length) {
				gsap.utils.toArray(".process-step").forEach((element) => {
					// Skip if already animated
					if (animatedElements.has(element)) {
						return;
					}

					const st = ScrollTrigger.create({
						trigger: element,
						start: "top 99%",
						end: "bottom 10%",
						toggleActions: "play none none none",
						// Remove markers for production
						// markers: true,
						animation: gsap.from(element, {
							duration: 1,
							opacity: 0,
							y: 30,
							ease: "power2.out",
							paused: true,
							onComplete: () => {
								// Mark as animated once complete
								animatedElements.add(element);
							}
						})
					});
					scrollTriggers.push(st);
				});
			}
		};

		// Desktop animation function
		const initDesktopAnimations = () => {
			const staggerWrappers = document.querySelectorAll(".fade-in-up-stagger-steps");
			
			if (!staggerWrappers.length) return;

			staggerWrappers.forEach((wrapper) => {
				// Skip if already animated
				if (animatedWrappers.has(wrapper)) {
					return;
				}

				const staggerItems = wrapper.querySelectorAll(".fade-in-up-stagger-step");

				if (staggerItems.length > 0) {
					const st = ScrollTrigger.create({
						trigger: wrapper,
						start: "top 95%",
						toggleActions: "play none none none",
						animation: gsap.from(staggerItems, {
							duration: 1,
							opacity: 0,
							y: 30,
							stagger: 0.5,
							ease: "power2.out",
							paused: true,
							onComplete: () => {
								// Mark wrapper as animated once complete
								animatedWrappers.add(wrapper);
								// Also mark individual items as animated
								staggerItems.forEach(item => animatedElements.add(item));
							}
						})
					});
					scrollTriggers.push(st);
				}
			});
		};

		// Initialize animations based on screen size
		const initAnimations = () => {
			clearScrollTriggers();
			
			if (isMobile()) {
				initMobileAnimations();
			} else {
				initDesktopAnimations();
			}
		};

		// Handle resize with better debouncing and breakpoint detection
		let resizeTimeout;
		const handleResize = () => {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(() => {
				const newBreakpoint = isMobile() ? 'mobile' : 'desktop';
				
				// Only re-initialize if breakpoint actually changed
				if (newBreakpoint !== currentBreakpoint) {
					currentBreakpoint = newBreakpoint;
					initAnimations();
				}
			}, 250);
		};

		// Initialize animations
		initAnimations();

		// Add resize listener
		window.addEventListener("resize", handleResize);

		// Return cleanup function for potential future use
		return () => {
			clearScrollTriggers();
			window.removeEventListener("resize", handleResize);
		};
	}

	// Initialize when DOM is ready and GSAP is available
	function init() {
		waitForGSAP().then(() => {
			if (document.readyState === "loading") {
				document.addEventListener("DOMContentLoaded", initProcessSteps);
			} else {
				initProcessSteps();
			}
		});
	}

	// Start initialization
	init();
})();
